import { GenerateInstallmentsDto } from '../../../../api';

// Opciones de frecuencia para el formulario (usa enums de la API)
export const FREQUENCY_OPTIONS = [
  { value: GenerateInstallmentsDto.frequency.WEEKLY, label: 'Semanal' },
  { value: GenerateInstallmentsDto.frequency.BIWEEKLY, label: 'Quincenal' },
  { value: GenerateInstallmentsDto.frequency.MONTHLY, label: 'Mensual' },
] as const;
